import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class TableLanguageService {

  constructor(private traslate: TranslateService) { }

  getLanguageTexts(): any {
      /* const language = {
        sProcessing: 'Procesando...',
        sLengthMenu: 'Mostrar _MENU_ registros',
        sZeroRecords: 'No se encontraron resultados',
        sEmptyTable: 'Ningún dato disponible en esta tabla',
        sInfo: 'Del _START_ al _END_ de _TOTAL_ registros',s
        sInfoEmpty: '',
        sInfoFiltered: '(filtrado de _MAX_ registros)',
        sInfoPostFix: '',
        sSearch: 'Buscar:',
        sUrl: '',
        sInfoThousands: '.',
        sLoadingRecords: 'Cargando...',
        oPaginate: {
          sFirst: 'Primero',
          sLast: 'Último',
          sNext: 'Siguiente',
          sPrevious: 'Anterior'
        },
        pagingType: 'simple_numbers',
        oAria: {
          sSortAscending: ': Activar para ordenar la columna de manera ascendente',
          sSortDescending: ': Activar para ordenar la columna de manera descendente'
        },
        buttons: {
          copy: 'Copiar',
          colvis: 'Visibilidad'
        },
      };*/
      const language = this.traslate.instant('table');
      return language;
  }

}
